import * as React from "react";
import { useMemo } from "react";
import { DataLake } from "@graylog/enterprise-api";
import RetrievalContext from "data-lake/preview/contexts/RetrievalContext";
import { EXTERNAL_DATA_LAKE_TYPE } from "data-lake/Constants";
const bulkRetrievePayload = (messages, dataLakeId, payload) => ({
  messages,
  data_lake_id: dataLakeId,
  type: EXTERNAL_DATA_LAKE_TYPE,
  table: payload.sourceId,
  timeout: void 0
});
const onRetrieveMessages = ({ data_lake_id, stream_ids, field_filters, operator }, from, to) => {
  const request = {
    data_lake_id,
    type: EXTERNAL_DATA_LAKE_TYPE,
    table: stream_ids[0],
    field_filters,
    operator
  };
  return DataLake.retrieveBulkRetrievalRequest(request, from, to);
};
const RetrievalProvider = ({ children }) => {
  const contextValue = useMemo(() => ({ bulkRetrievePayload, onRetrieveMessages }), []);
  return /* @__PURE__ */ React.createElement(RetrievalContext.Provider, { value: contextValue }, children);
};
export default RetrievalProvider;
